<dx-scroll-view class="view-wrapper-scroll">
  <div class="view-wrapper">
    <toolbar-analytics titleText="Sales Report"> </toolbar-analytics>

    <div class="cards wide">
      <sales-range-card
        [data]="sales"
        [(visualRange)]="visualRange"
        (salesRangeChanged)="onRangeChanged($event)"
      ></sales-range-card>

      <sales-by-range-card [data]="salesByCategory"></sales-by-range-card>

      <sales-performance-card
        [groupByPeriods]="groupByPeriods"
        [salesByDateAndCategory]="salesByDateAndCategory"
        [visualRange]="visualRange"
        (performancePeriodChanged)="selectionChange($event)"
      ></sales-performance-card>
    </div>
  </div>
</dx-scroll-view>
<dx-load-panel
  container=".view-wrapper"
  [position]="{ of: '.content' }"
  [visible]="isLoading"
  [showPane]="true"
></dx-load-panel>
